import React from 'react';
import PropTypes from 'prop-types';
// @mui
import { DialogTitle, DialogActions, IconButton, Box, Typography } from '@mui/material';
import Iconify from './Iconify';
import { DialogAnimate } from './animate';
import useLocales from '../hooks/useLocales';

// ----------------------------------------------------------------------

CustomModal.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  open: PropTypes.bool,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  hasClose: PropTypes.bool,
  children: PropTypes.node,
  isBackdropClosable: PropTypes.bool,
  hasTransition: PropTypes.bool,
};

export default function CustomModal({
  children,
  title = '',
  actions,
  open,
  onClose,
  hasClose = true,
  isBackdropClosable = true,
  PaperPropsSx = {},
  // hasTransition = true,
  ...other
}) {
  const { translate } = useLocales();

  const handleClose = (e, r) => {
    if (!isBackdropClosable && r === 'backdropClick') {
      return false;
    }

    if (!isBackdropClosable && r === 'escapeKeyDown') {
      return false;
    }

    onClose(e, r);
    return true;
  };

  return (
    <DialogAnimate
      fullWidth
      open={open}
      onClose={handleClose}
      scroll={'body'}
      PaperProps={{
        sx: {
          background:
            'radial-gradient(49.1% 56.8% at 50% 0%, rgba(38, 58, 89, 0.8) 0%, rgba(38, 58, 89, 0.63) 30.08%, rgba(7, 20, 44, 0.8) 100%)',
          backdropFilter: 'blur(4px)',
          overflow: 'unset',
          marginTop: { xs: 0, sm: hasClose ? '1.5rem !important' : 0 },
          ...PaperPropsSx,
        },
      }}
      BackdropProps={{ sx: { background: '#000c' } }}
      {...other}
    >
      <Box
        sx={{
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0) 26.03%, rgb(255, 255, 255) 48.56%, rgba(255, 255, 255, 0) 72.48%)',
          width: '100%',
          height: '1px',
          position: 'absolute',
          top: 0,
        }}
      />
      {hasClose && (
        <>
          <IconButton
            aria-label="close"
            onClick={() => onClose()}
            color="primary"
            size="small"
            sx={{
              position: 'absolute',
              right: 12,
              top: 12,
              zIndex: 2,
              color: '#fff',
              display: { xs: 'flex', sm: 'none' },
            }}
          >
            <Iconify icon={'ep:close'} sx={{ fontSize: '1.5rem' }} />
          </IconButton>
          <Box
            sx={{
              display: { xs: 'none', sm: 'flex' },
              alignItems: 'center',
              position: 'absolute',
              right: 0,
              top: -24,
              zIndex: 1,
              color: '#fff',
              gap: 0.5,
              cursor: 'pointer',
            }}
            onClick={() => onClose()}
          >
            <Typography sx={{ textDecoration: 'underline' }}>{translate('close')}</Typography>
            <Iconify icon={'ic:round-close'} />
          </Box>
        </>
      )}
      {title && <DialogTitle>{title}</DialogTitle>}
      {children}
      {actions && <DialogActions>{actions}</DialogActions>}
    </DialogAnimate>
  );
}
